import Assessment from "@mui/icons-material/Assessment";
import Audiotrack from "@mui/icons-material/Audiotrack";
import Delete from "@mui/icons-material/Delete";
import Description from "@mui/icons-material/Description";
import Folder from "@mui/icons-material/Folder";
import Image from "@mui/icons-material/Image";
import InsertDriveFile from "@mui/icons-material/InsertDriveFile";
import PlayCircle from "@mui/icons-material/PlayCircle";

import { FileType } from "../helpers/utils";

const FileIcon = (props: { type: FileType }) => {
  switch (props.type) {
    case FileType.IMAGE:
    case FileType.IMAGE_TIFF:
      return <Image />;
    case FileType.TEXT:
      return <Description />;
    case FileType.TABULAR:
      return <Assessment />;
    case FileType.TRASH:
      return <Delete />;
    case FileType.VIDEO:
      return <PlayCircle />;
    case FileType.AUDIO:
      return <Audiotrack />;
    case FileType.UNKNOWN:
      return <InsertDriveFile />;
    default:
      return <Folder />;
  }
};

export default FileIcon;
